/**
 * @generated SignedSource<<63f59ffdb61bb6b718da5d9559981d03>>
 * @relayHash 41c2d15720b8905d80888a4a7e5c4d96
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 41c2d15720b8905d80888a4a7e5c4d96

import { ConcreteRequest } from 'relay-runtime';
export type useCapacityPlansQuery$variables = {
  date: any;
};
export type useCapacityPlansQuery$data = {
  readonly capacityPlans: ReadonlyArray<{
    readonly additionalPoolCapacity: number;
    readonly additionalReservedCapacity: number;
    readonly availableEmergencyCapacity: number;
    readonly availablePoolCapacity: number;
    readonly bookedEmergencyCapacity: number;
    readonly bookedPoolCapacity: number;
    readonly date: any;
    readonly explanation: string;
    readonly forecastedCapacity: number;
    readonly id: string;
    readonly initialReservedCapacity: number;
    readonly isCurrentSlot: boolean;
    readonly overbookedEmergencyCapacity: number;
    readonly plannedEmergencyCapacity: number;
    readonly plannedPoolCapacity: number;
    readonly poolCapacity: number;
    readonly reservedCapacity: number;
    readonly slotId: number;
  }>;
};
export type useCapacityPlansQuery = {
  response: useCapacityPlansQuery$data;
  variables: useCapacityPlansQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "date"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "date",
        "variableName": "date"
      }
    ],
    "concreteType": "PoolCapacityValuesOutput",
    "kind": "LinkedField",
    "name": "capacityPlans",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "date",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slotId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "forecastedCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalPoolCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "additionalReservedCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "initialReservedCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reservedCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "plannedPoolCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "poolCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "explanation",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isCurrentSlot",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookedEmergencyCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bookedPoolCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availableEmergencyCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "availablePoolCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "overbookedEmergencyCapacity",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "plannedEmergencyCapacity",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCapacityPlansQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useCapacityPlansQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "41c2d15720b8905d80888a4a7e5c4d96",
    "metadata": {},
    "name": "useCapacityPlansQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0be47c2c9f3a80cb7de8e50cc3ee09ce";

export default node;
